var render, staticRenderFns
import script from "./GmbAttributeItem.vue?vue&type=script&lang=js&"
export * from "./GmbAttributeItem.vue?vue&type=script&lang=js&"
import style0 from "./GmbAttributeItem.vue?vue&type=style&index=0&id=78e1117e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e1117e",
  null
  
)

export default component.exports